import { logout } from "@/common/functions/authFunctions";
import { confirmDialog } from "@/components/containers/ConfirmDialog";
import { deleteFcmToken } from "@/common/functions/flutter";
import { ReactComponent as IconHome } from "@/styles/assets/svg/icon_home.svg";
import { ReactComponent as IconLink } from "@/styles/assets/svg/icon_link.svg";
import { ReactComponent as IconAlarm } from "@/styles/assets/svg/icon_alarmset.svg";
import { ReactComponent as IconCheer } from "@/styles/assets/svg/icon_cheerup.svg";
import { ReactComponent as IconSpine } from "@/styles/assets/svg/icon_spine.svg";
import { ReactComponent as IconTerms } from "@/styles/assets/svg/icon_terms.svg";
import { ReactComponent as IconNotice } from "@/styles/assets/svg/icon_notice.svg";
import { ReactComponent as IconMypage } from "@/styles/assets/svg/icon_myinfo.svg";
import { ReactComponent as IconLogout } from "@/styles/assets/svg/icon_logout.svg";
import { ReactComponent as IconHealth } from "@/styles/assets/svg/icon_healthinfo.svg";
import { ReactComponent as IconMessage } from "@/styles/assets/svg/icon_message.svg";
import { ReactComponent as IconInquire } from "@/styles/assets/svg/icon_inquire.svg";
import { ReactComponent as IconExercise } from "@/styles/assets/svg/icon_exercise.svg";

export const SideMenus = [
  {
    id: 1,
    menuTitle: "내 계정 관리",
    icon: <IconMypage />,
    path: "/setting/user",
  },
  {
    id: 2,
    menuTitle: "내 건강 정보 관리",
    icon: <IconHealth />,
    path: "/setting/health-info",
  },
  {
    id: 3,
    menuTitle: "법정보호자 연결 설정",
    icon: <IconLink />,
    path: "/setting/guardian",
  },
  {
    id: 4,
    menuTitle: "응원 메시지 내역",
    icon: <IconCheer />,
    path: "/comment/history",
  },
  {
    id: 5,
    menuTitle: "이벤트 및 공지",
    icon: <IconNotice />,
    path: "/setting/notice",
  },
  {
    id: 6,
    menuTitle: "알림 관리",
    icon: <IconAlarm />,
    path: "/setting/alarm",
  },
  {
    id: 7,
    menuTitle: "서비스 문의",
    icon: <IconInquire />,
    path: "/setting/inquiry",
  },
  {
    id: 8,
    menuTitle: "약관 및 정책",
    icon: <IconTerms />,
    path: "/setting/terms",
  },
  {
    id: 9,
    menuTitle: "로그아웃",
    icon: <IconLogout />,
    onClick: async () => {
      const isConfirm = await confirmDialog({
        text: "로그아웃 하시겠습니까??",
      });

      if (isConfirm) {
        if (window.WebViewChannel) {
          deleteFcmToken();
        }
        logout();
      }
    },
  },
];

export const TermMenus = [
  {
    id: 1,
    menuTitle: "서비스 이용 안내",
    path: "/setting/terms/attend",
  },
  {
    id: 2,
    menuTitle: "개인정보 수집・이용 및 제3자 제공 약관",
    path: "/setting/terms/use",
  },
  {
    id: 3,
    menuTitle: "사진활용 동의 약관",
    path: "/setting/terms/photo",
  },
];

export const NavMenus = [
  {
    userType: "학생 회원",
    menus: [
      {
        id: 1,
        title: "홈",
        icon: <IconHome width={28} height={28} />,
        path: "/home",
      },
      {
        id: 2,
        title: "척추건강",
        icon: <IconSpine width={28} height={28} />,
        path: "/spine",
      },
      {
        id: 3,
        title: "운동하기",
        icon: <IconExercise width={28} height={28} />,
        path: "/exercise",
      },
    ],
  },
  {
    userType: "보호자회원",
    menus: [
      {
        id: 1,
        title: "홈",
        icon: <IconHome width={28} height={28} />,
        path: "/home",
      },
      {
        id: 2,
        title: "학생건강",
        icon: <IconSpine width={28} height={28} />,
        path: "/spine",
      },
      {
        id: 3,
        title: "응원하기",
        icon: <IconMessage width={28} height={28} />,
        path: "/comment",
      },
    ],
  },
];

export const UserSideMenus = [
  {
    id: 1,
    title: "아이디 변경",
    path: "/setting/user/account-id-edit",
  },
  {
    id: 2,
    title: "비밀번호 변경",
    path: "/setting/user/account-pw-edit",
  },
  {
    id: 3,
    title: "회원정보 수정",
    path: "/setting/user/student-edit",
    type: "student",
  },
  {
    id: 4,
    title: "회원정보 수정",
    path: "/setting/user/guardian-edit",
    type: "guardian",
  },
];

export const InquirySideMenus = [
  {
    id: 1,
    title: "자주 묻는 질문",
    path: "/setting/inquiry/faq/ACCOUNT",
  },
  {
    id: 2,
    title: "1:1 문의",
    path: "/setting/inquiry/contacts",
  },
];
